<template>
  <div>
    <div class="sub-list">
      <div class="item row" v-for="(news, index) in data" :key="index" @click.prevent="goNewsById(news.newsId)">
        <div class="col-4 text-center time">
          <p>{{news.time}}</p>
          <p v-if="checkUpdate(data.timeFormat)" class="new">New!!</p>
        </div>
        <div class="col-8 detail">
          <p>{{news.header}}</p>
        </div>
      </div>
      <div class="continue text-center" @click.prevent="goNewsPage()">
        <span>{{ moreNews }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  props: ['data', 'moreNews'],
  methods: {
    goNewsPage: function () {
      this.$router.push({ name: 'news', params: { lang: this.$route.params.lang } })
    },
    checkUpdate: function (time) {
      var diffDays = moment().diff(moment(time, 'DD-MM-YYYY'), 'days')
      return diffDays < 7
    },
    goNewsById (newsId) {
      this.$emit('goNewsById', newsId)
    }
  }
}
</script>

<style scoped>

  .continue.active {
    background-color: #FFF;
  }

  .continue.active img {
    width: 40px;
  }

  .new {
    color: #F00 !important;
    font-size: 18px !important;
    animation-name: new;
    animation-duration: 1.5s;
    animation-iteration-count: infinite;
  }

  @keyframes new {
    0% {
      transform: scale(1,1);
    }
    50% {
      transform: scale(1.2,1.2);
    }
    100% {
      transform: scale(1,1);
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/HOME/ScrollingNews.vue